import { useContext } from 'react';
import { FieldFlowMode } from '../../FieldControlled/common.js';
import FormFieldPropertiesContext from '../../Form/FormFieldPropertiesContext.js';

function useFormFlowMode(flowMode) {
    const props = useContext(FormFieldPropertiesContext);
    if (flowMode !== undefined) {
        return flowMode;
    }
    if (props.flowMode !== undefined) {
        return props.flowMode;
    }
    return FieldFlowMode.NONE;
}

export { useFormFlowMode as default };
